import React from 'react';

export default function InfiniteSlider({ reviews }) {
  if (!reviews || reviews.length === 0) return null;

  // Duplicate the reviews to ensure seamless infinite scrolling
  const duplicatedReviews = [...reviews, ...reviews, ...reviews, ...reviews];

  return (
    <div className="relative w-full overflow-hidden py-10 bg-slate-50">
      {/* Left & Right Gradient Overlays for a premium fade effect */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 sm:w-32 bg-gradient-to-r from-slate-50 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 sm:w-32 bg-gradient-to-l from-slate-50 to-transparent" />

      {/* Marquee Track */}
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused] gap-6">
        {duplicatedReviews.map((review, idx) => (
          <div
            key={`${review.id || idx}-${idx}`}
            className="w-[280px] sm:w-[350px] md:w-[400px] flex-shrink-0 bg-white p-6 sm:p-8 rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-between"
          >
            <div>
              {/* Star Rating */}
              <div className="flex items-center gap-1 text-amber-400 mb-4">
                {[...Array(review.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-sm" />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-slate-600 text-sm sm:text-base leading-relaxed italic">
                "{review.review}"
              </p>
            </div>

            {/* Reviewer Info */}
            <div className="mt-6 pt-4 border-t border-slate-100 flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-700 font-bold text-sm border border-slate-200">
                {review.name ? review.name.charAt(0) : 'K'}
              </div>
              <div>
                <h4 className="font-semibold text-slate-900 text-sm sm:text-base">
                  {review.name}
                </h4>
                <p className="text-xs text-slate-500 flex items-center gap-1">
                  <i className="fa-regular fa-location-dot text-emerald-600" />
                  {review.location}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
